module.exports = __webpack_public_path__ + "img/barcelo-room-4.43129df5.jpg";